// Sidebar
const SIDEBAR_VISIBILITY_TOGGLE = 'SIDEBAR_VISIBILITY_TOGGLE';
const SIDEBAR_VISIBILITY_SHOW = 'SIDEBAR_VISIBILITY_SHOW';
const SIDEBAR_VISIBILITY_HIDE = 'SIDEBAR_VISIBILITY_HIDE';


// Auth
const AUTH_SUCCESS = 'AUTH_SUCCESS';
const AUTH_CLEAR = 'AUTH_CLEAR';
const AUTH_SET_USER = 'AUTH_SET_USER';

// Common Actions
const LOAD_STATUS = 'LOAD_STATUS';
const SAVE_STATUS = 'SAVE_STATUS';
const SET_META = 'SET_META';
const SET_ITEMS = 'SET_ITEMS';
const SET_FILTERS = 'SET_FILTERS';
const SET_SORTING = 'SET_SORTING';

// Statistics
const STATISTICS_SET_ITEMS = 'STATISTICS_SET_ITEMS';
const STATISTICS_SET_FILTERS = 'STATISTICS_SET_FILTERS';

// Navbar
const NAVBAR_SET_META = 'NAVBAR_SET_META';
const NAVBAR_SET_ITEMS = 'NAVBAR_SET_ITEMS';

export {
	SIDEBAR_VISIBILITY_TOGGLE,
	SIDEBAR_VISIBILITY_SHOW,
	SIDEBAR_VISIBILITY_HIDE,
	AUTH_SUCCESS,
	AUTH_CLEAR,
	AUTH_SET_USER,
	LOAD_STATUS,
	SAVE_STATUS,
	SET_META,
	SET_ITEMS,
	SET_FILTERS,
	SET_SORTING,
	STATISTICS_SET_ITEMS,
	STATISTICS_SET_FILTERS,
	NAVBAR_SET_META,
	NAVBAR_SET_ITEMS
}
